export default __webpack_public_path__ + "static/media/season_3_mapfull.99ce2c40.png";